
import { Headline, HtmlContainer } from "@n2-common/ui";
import { ApplicationStatusPage, CommonStatusPageProps } from "../../components/ApplicationStatusPage";
import { useTranslation } from "react-i18next";
import { N2MajorApplicationStatus } from "@n2-common/serverGeneratedTypings/n2MajorApplicationStatus";
import { useApplicationIdContext } from "@n2-common/components/ApplicationContext";
import { translationNamepaceFromProduct } from "../applicationStatusHelpers";

const  ApplicantActionsCompletedPage = ({ navigateToCorrectStepFunc }: CommonStatusPageProps): JSX.Element => {
    const { productType } = useApplicationIdContext();

    const translationNameSpace = translationNamepaceFromProduct(productType);
    
    const { t } = useTranslation(translationNameSpace);
    
    return <ApplicationStatusPage navigateToCorrectStepFunc={navigateToCorrectStepFunc} 
        correctStateFunc={(res) => res.MajorStatus === N2MajorApplicationStatus.Aproved} >
        <Headline>{t<string>("ApplicationLandingPages.ApplicantActionsCompleted.Headline")}</Headline>
         <h2>{t<string>("ApplicationLandingPages.ApplicantActionsCompleted.SubHeadline")}</h2>  
         <HtmlContainer innerHtml={t<string>("ApplicationLandingPages.ApplicantActionsCompleted.Body")} />     
    </ApplicationStatusPage>
};

export default ApplicantActionsCompletedPage;